import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VehicleEnrouteIconComponent } from './vehicle-enroute-icon.component';
import { GoogleMapsModule } from '@angular/google-maps';



@NgModule({
  declarations: [VehicleEnrouteIconComponent],
  exports: [VehicleEnrouteIconComponent],
  imports: [
    CommonModule,
    GoogleMapsModule,
  ]
})
export class VehicleEnrouteIconModule { }
